import { render, staticRenderFns } from "./digikalaOrderItemsList.vue?vue&type=template&id=3a0174ac&scoped=true&"
import script from "./digikalaOrderItemsList.vue?vue&type=script&lang=js&"
export * from "./digikalaOrderItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0174ac",
  null
  
)

export default component.exports